<div>
    <div class="container-fluid fixed-top ">
        <app-header></app-header>
    </div>
    <div class="hero-header slide-container" id="top-page">

        <app-slider></app-slider>
    </div>

    <div class="container">
        <app-offers-info [numSlides]="3" [title]="'Nuestras Ofertas'"></app-offers-info>
    </div>

    <div class="container-fluid fruite">
        <app-product-section></app-product-section>
    </div>

    <div>
        <app-footer></app-footer>
    </div>
</div>